import { PluginKey } from 'prosemirror-state';
export var stateKey = new PluginKey('tasksAndDecisionsPlugin');